export { CVCIcon } from './cvc'
